export { default } from './SeoSettings.vue'
